// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"f9375bd4d31dc115","6533":"cca5cf4530515ae1"}[chunkId] + ".css";
};